import { render } from "./Agreement.vue?vue&type=template&id=7cd53de0&scoped=true&ts=true&lang=pug"
import script from "./Agreement.vue?vue&type=script&setup=true&lang=ts"
export * from "./Agreement.vue?vue&type=script&setup=true&lang=ts"

import "./Agreement.vue?vue&type=style&index=0&id=7cd53de0&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd53de0"]])

export default __exports__